import FingerprintJS from "@fingerprintjs/fingerprintjs";

let cachedFingerprint: string | null = null;
let fingerprintPromise: Promise<string> | null = null;

const getFingerprint = async () => {
  if (cachedFingerprint) {
    return cachedFingerprint;
  }

  if (!fingerprintPromise) {
    fingerprintPromise = (async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      cachedFingerprint = result.visitorId;
      return cachedFingerprint;
    })().finally(() => {
      fingerprintPromise = null;
    });
  }

  return fingerprintPromise;
};
export default getFingerprint;
